import Vue from "vue";

Vue.directive("orphan", {
  bind: function (el) {
    el.innerHTML = el.innerHTML.trim().replace(/\s([^\s]*)$/, "&nbsp;" + "$1");
  }
});
